export enum TPATStates {
  PAT_PLAY_DESIGN = 'PAT_PLAY_DESIGN',
  XP_ATTEMPT = 'XP_ATTEMPT',
  TWO_PT_ATTEMPT = 'TWO_PT_ATTEMPT',
  XP_ATTEMPT_SNAP = 'XP_ATTEMPT_SNAP',
  TWO_PT_ATTEMPT_SNAP = 'TWO_PT_ATTEMPT_SNAP',
  TWO_PT_RETURN_ONE_PT_SAFTEY = 'TWO_PT_RETURN_ONE_PT_SAFTEY',
  CONFIRM_PAT = 'CONFIRM_PAT',
  REF_EVENT = 'REF_EVENT',
  SELECT_YARDAGE = 'SELECT_YARDAGE',
}

export enum TPATPlayEvents {
  BACK = 'BACK',
  BACK_TO_XP_ATTEMPT = 'BACK_TO_XP_ATTEMPT',
  TO_TWO_PT_ATTEMPT = 'TO_TWO_PT_ATTEMPT',
  TO_XP_ATTEMPT = 'TO_XP_ATTEMPT',
  ON_XP_MADE = 'ON_XP_MADE',
  ON_XP_MISS = 'ON_XP_MISS',
  ON_TWO_PT_RETURN_ONE_PT_SAFTEY = 'ON_TWO_PT_RETURN_ONE_PT_SAFTEY',
  PAT_COMPLETED = 'PAT_COMPLETED',
  BACK_TO_TWO_PT_ATTEMPT = 'BACK_TO_TWO_PT_ATTEMPT',
  BACK_TO_TWO_PT_RETURN_ONE_PT_SAFTEY = 'BACK_TO_TWO_PT_RETURN_ONE_PT_SAFTEY',
  REF_EVENT = 'REF_EVENT',
  BACK_TO_PAT_PLAY_DESIGN = 'BACK_TO_PAT_PLAY_DESIGN',
  TO_GAME_OVER = 'TO_GAME_OVER',
  PAT_PENALTY = 'PAT_PENALTY',
  BACK_TO_YARDAGE = 'BACK_TO_YARDAGE',
  OVERTIME_PAT_COMPLETE = 'OVERTIME_PAT_COMPLETE',
}
